/**
 * The ProductSubscription component is used to set selling plans.
 * @param {number} index 
 * @param {HTMLElement} element 
 */

var $plan_select = $("select[ name='selling_plan' ]");
var $plan_frequency = $('.product__subscription-frequency');
var $one_time_button = $('#one-time-purchase');
var $subscription_button = $('#subscription-purchase');
var $subscription_extra_text = $('.product__text.subscription-text');
var $one_time_extra_text = $('.product__text.one-time-text');
var $phyllup_pdp_callout = $('.phyllup-subscription-callout');
var $phyllup_callout_onetime = $('.phyllup-onetime');
var $phyllup_callout_subscription = $('.phyllup-subscription');

$one_time_button.click(function() {
  $('.product__subscription .sub-group').removeClass('is-selected');
  $(this).addClass('is-selected');
  $plan_frequency.hide();
  $subscription_extra_text.addClass('hide');
  $one_time_extra_text.removeClass('hide');

  $phyllup_pdp_callout.removeClass('active');
  $phyllup_callout_onetime.addClass('active');

  $plan_select.prop("disabled", true);
});
$subscription_button.click(function() {
  $('.product__subscription .sub-group').removeClass('is-selected');
  $(this).addClass('is-selected');
  $plan_frequency.show();
  $subscription_extra_text.removeClass('hide');
  $one_time_extra_text.addClass('hide');
  
  $phyllup_pdp_callout.removeClass('active');
  $phyllup_callout_subscription.addClass('active');
  
  $plan_select.prop("disabled", false);
});



/**
 * The QuantitySelector component is used to quantify a product via single decrements and increments.
 * @param {number} index 
 * @param {HTMLElement} element 
 */
function QuantitySelector( index, element ) {
  this.$element = $( element );
  this.index = index;

  this.selectors = {
    input: ".quantity-selector__input",
    plus: ".quantity-selector__plus",
    minus: ".quantity-selector__minus",
    count: ".quantity-selector__count",
    unit: ".quantity-selector__unit"
  }

  this.initialize();
}

QuantitySelector.prototype = Object.assign( {}, QuantitySelector.prototype, {
  initialize: function() {
    const min = this.$element.data( "min" );

    // If a min is provieded, use it.
    this.min = min != '' ? parseInt( min ) : 1;

    this.$input = this.$element.find( this.selectors.input );
    this.$plus = this.$element.find( this.selectors.plus );
    this.$minus = this.$element.find( this.selectors.minus );
    this.$count = this.$element.find( this.selectors.count );
    this.$unit = this.$element.find( this.selectors.unit );


    this.$plus.on( "click", this._handlePlus.bind( this ) );
    this.$minus.on( "click", this._handleMinus.bind( this ) );
  },

  _updateQuantifier: function( value ) {
    const singular = this.$unit.data( "single" );
    const plural = this.$unit.data( "plural" ); 
    // If there's no set singular text, use current text.
    let quantifier = singular ? singular : this.$unit.text();
    // If no plural text is provided, add an 's' by default.
    let pluralText = plural ? plural : `${ singular }s`;

    // If there's more than 1, set quantifier to plural.
    if( value > 1 ) quantifier = pluralText;

    this.$unit.text( quantifier );
  },

  _updateQuantity: function( value ) {
    // Update the input value.
    this.$input.val( value );

    // Update the visual count.
    this.$count.text( value );

    // Update the quantifier.
    this._updateQuantifier( value );
  },

  _handlePlus: function( event ) {
    const currentCount = parseInt( this.$input.val() );

    this._updateQuantity( currentCount + 1 );
  },

  _handleMinus: function( event ) {
    const currentCount = parseInt( this.$input.val() );

    // Only decrease count when it's greater than the minimum.
    if( currentCount > this.min )
      this._updateQuantity( currentCount - 1 );
  }
} );

$( ".quantity-selector" ).each( function( index, element ) {
  const quantitySelector = new QuantitySelector( index, element );
} );



class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartNotification.renderContents(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}

customElements.define('product-form', ProductForm);
